import AuthForm from "@/components/common/auth-form";
import Modal from "@/components/ui/modal";
import Image from "next/image";

type AuthModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onAuthSuccess?: () => void;
};

function AuthModal({ isOpen, onClose, onAuthSuccess }: AuthModalProps) {
	const handleSuccess = () => {
		onClose();
		onAuthSuccess?.();
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} className="max-w-md px-4 pb-4 pt-2">
			<div className="mb-2 flex h-36 w-full items-center justify-center rounded-lg bg-gradient-to-r from-brand-primary/5 via-brand-primary/20 to-brand-primary/5 py-2">
				<Image
					src="/images/proptechbuzz-logo.svg"
					alt="PropTechBuzz Logo"
					width={48}
					height={48}
					className="h-full w-48 fill-[#271B58]"
				/>
			</div>
			<AuthForm onSuccess={handleSuccess} />
		</Modal>
	);
}

export default AuthModal;
